import reactComponentLoader from 'scripts/react-component-loader'

import Cart from './Cart'

reactComponentLoader(Cart, '[data-cart]')
